export const SEND_MESSAGE = 'send_message';
export const CALL_API = 'call_api';
export const CALL_FUNCTION = 'call_function';
export const EVAL_NEXT = 'eval_next';
export const MAP_RESULT = 'map_result';
export const STORE_DATA = 'store_data';
export const STORE_FILE = 'store_file';
export const CONDITIONAL_STEP = 'conditional_step';
export const NOT_DEFINED = 'NOT_DEFINED';
export const COMMENT = 'comment';

export const ItemTypes = {
  BOTSPEC: 'botspec',
  FOLDER: 'folder',
};

export const SEND_MESSAGE_LABEL = 'Send Message';
export const CALL_API_LABEL = 'Call Api';
export const CALL_FUNCTION_LABEL = 'Call Function';
export const EVAL_NEXT_LABEL = 'Eval Next';
export const MAP_RESULT_LABEL = 'Map Result';
export const STORE_DATA_LABEL = 'Store Data';
export const CONDITIONAL_STEP_LABEL = 'Conditional Step';
export const STORE_FILE_LABEL = 'Store File';
export const NOT_DEFINED_LABEL = 'Not Defined';
export const COMMENT_LABEL = 'Comment';

export const CLONE = 'clone';
export const DELETE = 'delete';
export const CLONE_LABEL = 'Clone';
export const DELETE_LABEL = 'Delete';

export const ACTION_TYPES = {
  SEND_MESSAGE,
  CALL_API,
  MAP_RESULT,
  EVAL_NEXT,
  STORE_DATA,
  CALL_FUNCTION,
  CONDITIONAL_STEP,
  STORE_FILE,
};

export const SEND_MESSAGE_DESCRIPTION = 'Use to send a message with the right input type to the client and expect data. Files can be sent by giving the right media url as parameter.';
export const CALL_API_DESCRIPTION = 'Define parameters to call HTTP endpoints. It supports all HTTP methods, query strings with \'params\', headers and body payloads. The response will be added inside the transition as \'eval_response\'.';
export const CALL_FUNCTION_DESCRIPTION = 'Use to execute functions, conditions for instance. Useful to calculate the next state in chatbot executions.';
export const EVAL_NEXT_DESCRIPTION = 'We use the same syntax as Call Function, but Eval Next signals developers that a conditional transition is taking place. The output of the function will be a string that matches the next dictionary conditionals.';
export const MAP_RESULT_DESCRIPTION = 'Define mapping data in order to read or write arbitrary JSON API responses and perform variables assignment. This is useful when building payloads to call APIs or to read API responses and perform assignments.';
export const STORE_DATA_DESCRIPTION = 'Used to store files in a storage service (s3, azure, gcloud).';
export const CONDITIONAL_STEP_DESCRIPTION = 'We use the same syntax as Call Function, but Conditional Step signals developers that a conditional transition is taking place. The output of the function will be a string that matches the next dictionary conditionals.';
export const STORE_FILE_DESCRIPTION = 'Used to store files in a storage service (s3, azure, gcloud).';
